export const MAX_COMPILE_LOOPS = 500